import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/ApplicationContext";
import { Button, Modal } from "react-bootstrap";

import { IReminderModalProps } from "./IReminderModalProps";
import { tableReminder } from "../../../services/Service";
import { Dropdown, DropdownItemProps } from "semantic-ui-react";

export const ReminderModal: React.FC<IReminderModalProps> = (
  props: IReminderModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [payValue, setPayValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [hour, setHour] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);

  useEffect(() => {
    setError(false);
    setHour(0);
    setMinutes(0);
  }, [props.show]);

  const hourOptions: DropdownItemProps[] = [];
  const minOptions: DropdownItemProps[] = [];

  for (let i = 0; i < 12; i++) {
    hourOptions.push({ key: i, text: i, value: i });
  }

  for (let i = 0; i < 60; i++) {
    minOptions.push({ key: i, text: i, value: i });
  }

  const onHourChange = (event: any, result: any) => {
    const { name, value } = result || event.target;
    setHour(parseInt(value));
  };

  const onMinutesChange = (event: any, result: any) => {
    const { name, value } = result || event.target;
    setMinutes(parseInt(value));
  };

  const paymentScreen = () => (
    <>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          fontSize: 16,
          display: "flex",
        }}
      >
        <>
          <Dropdown
            placeholder="Hours"
            selection
            onChange={onHourChange}
            options={hourOptions}
          />
          <span style={{ padding: 10 }}></span>

          <Dropdown
            placeholder="Minutes"
            selection
            onChange={onMinutesChange}
            options={minOptions}
          />
        </>
      </div>
    </>
  );

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Reminder</Modal.Title>
          </Modal.Header>
          <Modal.Body>{paymentScreen()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="secondary"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: 20,
                }}
                onClick={() => props.close()}
              >
                Cancel
              </Button>
            </div>

            <Button
              variant="success"
              style={{
                width: 300,
                height: 50,
                fontSize: 20,
              }}
              onClick={() => addReminderInMin()}
            >
              Add Reminder
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  async function addReminderInMin() {
    let totalMins = hour * 60;
    totalMins = totalMins + minutes;

    const isSaved = await tableReminder(
      props.table.uuid,
      context.AuthenticatedUser.getToken(),
      "" + totalMins
    );

    if (!isSaved) {
      setError(true);
      return;
    }

    props.close();
  }

  return (
    <>
      <>{customerModal()}</>
    </>
  );
};
